<template>
  <div v-if="data !== null">
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <!-- Card för screening consent -->
          <div class="clearfix"></div>
          <div class="card--wrapper" v-if="currentChild && currentChild.below13">
            <div class="card">
              <h4 class="text-primary-fh left-header">
                Samtycke för {{currentChild.firstName + ' ' + currentChild.lastName}}
              </h4>
              <p v-html="data.welcomepage.consentScreeningCaregiver"></p>
              <!-- Du är indexpatient -->
              <button
              v-if="isIndexPatient"
              class="btn btn-primary btn-lg btn-block"
              @click="indexPatientConsentScreening(consentScreening = true)"
              :class="currentChild.consentScreening === true ? 'consent-choice': ''">Ja</button>
              <!-- Du är sekundär vårdnadshavare -->
              <button
              v-if="isSecondaryCaregiver"
              class="btn btn-primary btn-lg btn-block"
              @click="secondaryCaregiverConsentScreening(consentScreening = true)"
              :class="currentChild.consentScreening === true ? 'consent-choice': ''">Ja</button>
              <div class="clearfix--min"></div>
              <!-- Du är indexpatient -->
              <button
              v-if="isIndexPatient"
              class="btn btn-primary btn-lg btn-block"
              @click="indexPatientConsentScreening(consentScreening = false)"
              :class="currentChild.consentScreening === false ? 'consent-choice': ''">Nej</button>
              <!-- Du är sekundär vårdnadshavare -->
              <button
              v-if="isSecondaryCaregiver"
              class="btn btn-primary btn-lg btn-block"
              @click="secondaryCaregiverConsentScreening(consentScreening = false)"
              :class="currentChild.consentScreening === false ? 'consent-choice': ''">Nej</button>
            </div>
            <div class="clearfix--min"></div>
            <div class="alert alert-success alert-consent-screening" v-if="consentScreening">
              <strong>
                Du har nu gett samtycke för screening gällande {{currentChild.firstName + ' ' + currentChild.lastName}}.
              </strong>
            </div>
            <div class="alert alert-warning alert-consent-screening" v-if="!consentScreening">
              <strong>
                Du har valt att <i>inte</i> ge samtycke för screening gällande {{currentChild.firstName + ' ' + currentChild.lastName}}.
              </strong>
            </div>
            <div class="clearfix"></div>
          </div>
          <!-- Card för research consent -->
          <div class="card--wrapper" v-if="currentChild">
            <div class="card">
              <h4 class="text-primary-fh left-header">
                Samtycke för {{currentChild.firstName + ' ' + currentChild.lastName}}
              </h4>
              <p v-html="data.welcomepage.consentResearchCaregiver"></p>
              <!-- Du är indexpatient -->
              <button
              v-if="isIndexPatient"
              class="btn btn-primary btn-lg btn-block"
              @click="indexPatientConsentResearch(consentResearch = true)"
              :class="currentChild.consentResearch === true ? 'consent-choice': ''">Ja</button>
              <!-- Du är sekundär vårdnadshavare -->
              <button
              v-if="isSecondaryCaregiver"
              class="btn btn-primary btn-lg btn-block"
              @click="secondaryCaregiverConsentResearch(consentResearch = true)"
              :class="currentChild.consentResearch === true ? 'consent-choice': ''">Ja</button>
              <div class="clearfix--min"></div>
              <!-- Du är indexpatient -->
              <button
              v-if="isIndexPatient"
              class="btn btn-primary btn-lg btn-block"
              @click="indexPatientConsentResearch(consentResearch = false)"
              :class="currentChild.consentResearch === false ? 'consent-choice': ''">Nej</button>
              <!-- Du är sekundär vårdnadshavare -->
              <button
              v-if="isSecondaryCaregiver"
              class="btn btn-primary btn-lg btn-block"
              @click="secondaryCaregiverConsentResearch(consentResearch = false)"
              :class="currentChild.consentResearch === false ? 'consent-choice': ''">Nej</button>
            </div>
            <div class="clearfix--min"></div>
            <div class="alert alert-success alert-consent-research" v-if="consentResearch">
              <strong>
                Du har nu gett samtycke för forskning gällande {{currentChild.firstName + ' ' + currentChild.lastName}}.
              </strong>
            </div>
            <div class="alert alert-warning alert-consent-research" v-if="!consentResearch">
              <strong>
                Du har valt att <i>inte</i> ge samtycke för forskning gällande {{currentChild.firstName + ' ' + currentChild.lastName}}.
              </strong>
            </div>
            <div class="clearfix"></div>
          </div>
          <button class="btn btn-outline-dark btn-lg btn-block" @click="goToWelcomeRoute()">
            &#8592; Tillbaka
          </button>
          <div class="clearfix"></div>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { request } from '../plugins/datocms'
import $ from 'jquery'

export default {
  name: 'consentminor',
  components: {
    Top,
    Bottom
  },
  props: ['id'],
  data () {
    return {
      data: null,
      research: null,
      consentScreening: null,
      consentResearch: null,
      isSecondaryCaregiver: sessionStorage.getItem('isSecondaryCaregiver') === 'true',
      isIndexPatient: sessionStorage.getItem('isIndexPatient') === 'true',
      allChildren: [],
      children: []
    }
  },
  methods: {
    goToWelcomeRoute () {
      window.location.href = window.location.origin.concat('/welcome')
    },
    indexPatientConsentScreening () {
      const r = confirm('Är du säker på ditt beslut?')
      if (r) {
        let loader = this.$loading.show()
        const childPersonId = parseInt(this.$props.id)
        axios.postConsentChild(config.childrenUnder13Uri + config.consentScreeningUri,
          childPersonId, this.consentScreening).then(response => {
          if (response) {
            loader.hide()
            $('.alert-consent-screening').show().delay(config.msInterval).fadeOut()
            this.currentChild.consentScreening = this.consentScreening
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Giving consent to screening for child went bad: ' + error)
            loader.hide()
          }
        })
      }
    },
    indexPatientConsentResearch () {
      const r = confirm('Är du säker på ditt beslut?')
      if (r) {
        let loader = this.$loading.show()
        const childPersonId = parseInt(this.$props.id)
        let url = config.childrenUnder13Uri + config.consentResearchUri
        if (this.currentChild && this.currentChild.below13 === false) {
          url = config.childrenbetween13and15Uri + config.consentResearchUri
        }
        axios.postConsentChild(url, childPersonId, this.consentResearch).then(response => {
          if (response) {
            loader.hide()
            $('.alert-consent-research').show().delay(config.msInterval).fadeOut()
            this.currentChild.consentResearch = this.consentResearch
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Giving consent to research for child went bad: ' + error)
            loader.hide()
          }
        })
      }
    },
    secondaryCaregiverConsentScreening () {
      const r = confirm('Är du säker på ditt beslut?')
      if (r) {
        let loader = this.$loading.show()
        const childPersonId = parseInt(this.$props.id)
        axios.postConsentChild(config.secondaryCaregiverUri + config.consentScreeningUri,
          childPersonId, this.consentScreening).then(response => {
          if (response) {
            loader.hide()
            $('.alert-consent-screening').show().delay(config.msInterval).fadeOut()
            this.currentChild.consentScreening = this.consentScreening
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Giving consent to screening for child went bad: ' + error)
            loader.hide()
          }
        })
      }
    },
    secondaryCaregiverConsentResearch () {
      const r = confirm('Är du säker på ditt beslut?')
      if (r) {
        let loader = this.$loading.show()
        const childPersonId = parseInt(this.$props.id)
        axios.postConsentChild(config.secondaryCaregiverUri + config.consentResearchUri,
          childPersonId, this.consentResearch).then(response => {
          if (response) {
            loader.hide()
            $('.alert-consent-research').show().delay(config.msInterval).fadeOut()
            this.currentChild.consentResearch = this.consentResearch
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Giving consent to research for child went bad: ' + error)
            loader.hide()
          }
        })
      }
    },
    async getAllChildren () {
      let loader = this.$loading.show()
      axios._get(config.secondaryCaregiverUri + config.allChildrenUri).then(response => {
        this.allChildren = response.data.childrenConsents
        loader.hide()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get all children that need consent: ' + error)
          loader.hide()
        }
      })
    },
    /* eslint-disable no-return-assign */
    async getChildren () {
      let loader = this.$loading.show()
      axios._get(config.childrenUnder13Uri + config.allChildrenUri).then(response => {
        if (response && response.data.childrenConsents.length > 0) {
          this.children = response.data.childrenConsents
        }
        axios._get(config.childrenbetween13and15Uri + config.consentResearchUri).then(response => {
          if (response && response.data.childrenConsents.length > 0) {
            for (var c of response.data.childrenConsents) {
              this.children.push(c)
            }
          }
          loader.hide()
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not get children age span 13-15 with need of consent: ' + error)
            loader.hide()
          }
        })
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get children with testresults: ' + error)
          loader.hide()
        }
      })
    }
  },
  computed: {
    currentChild () {
      if (this.children && this.children.length > 0) {
        return this.children.find(c => c.personId === parseInt(this.$props.id))
      }
      if (this.allChildren && this.allChildren.length > 0) {
        return this.allChildren.find(c => c.personId === parseInt(this.$props.id))
      }
    }
  },
  async beforeMount () {
    if (this.isSecondaryCaregiver) {
      await this.getAllChildren()
    }
    if (this.isIndexPatient) {
      await this.getChildren()
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          welcomepage {
            consentResearchCaregiver
            consentScreeningCaregiver
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card {
  background: rgb(240, 235, 235);
  padding: 1em;
}
.alert {
  display: none;
}
button:disabled,
button[disabled] {
  opacity: 0.2;
}
.consent-choice::after {
  content: ' (ditt val) ✓'
}
</style>



// WEBPACK FOOTER //
// src/components/ConsentMinor.vue